import React, { Fragment, memo, useCallback, useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import AppPageHeader from '../../components/AppPageHeader'
import DashboardLayout from '../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet/es/Helmet'
import { Button, Pagination, Space } from 'antd'
import {
  CellEclipseBox,
  TableBottomPaginationBlock,
} from '../../components/Common/Table'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import {
  CloseCircleOutlined,
  FilterOutlined,
  PaperClipOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons'
import uuid from 'uuid'
import FileDownload from 'js-file-download'
import moment from 'moment'
import AdvanceFilterBlock from './AdvanceFilterBlock'
import TableComponent from '../../components/Common/TableComponent'
import { ACL_ACTION_TYPE, DATE_FORMAT_DEFAULT } from '../../constants'
import AccessControlAction from '../../components/AccessControlAction'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'
import { AppTable } from '../../components/AppTable/AppTable'
import { DownloadMinimalisticOutlineIcon } from '../../components/AppIcon'
import { blue } from '../../color'
import DocumentVBPCPageAdvanceFilterV2 from './DocumentVBPCPageAdvanceFilterV2'

const DocumentVBPCPage = props => {
  const { loadingAnimationStore, documentStore, history } = props

  const { listVBPC, totalCount, filterVBPC } = documentStore

  const downloadFile = useCallback(
    async record => {
      try {
        loadingAnimationStore.showSpinner(true)
        const { data: attachmentBlob } = await documentStore.getAttachmentVBPC({
          recordId: record.id,
          fileId: record.file_id,
        })
        const {
          data: { attachments },
        } = await documentStore.getVBPCDetail(record.id)
        const blob = new Blob([attachmentBlob], { type: 'application/pdf' })
        const attachmentInfo = attachments.find(
          attachment => attachment.id === record.file_id
        )
        FileDownload(blob, attachmentInfo.name)
      } catch (error) {
        console.error(error)
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    },
    [documentStore, loadingAnimationStore]
  )

  /**
   * @type {import('antd').TableColumnsType}
   */
  const tableColumn = [
    {
      title: 'Tên văn bản',
      align: 'left',
      render: record => record?.document_name,
    },
    {
      title: 'Số quyết định ban hành',
      render: record => (
        <CellEclipseBox>{record?.document_number}</CellEclipseBox>
      ),
    },
    {
      title: 'Ngày ban hành',
      render: record => (
        <CellEclipseBox>
          <time>{moment(record?.issue_date).format(DATE_FORMAT_DEFAULT)}</time>
        </CellEclipseBox>
      ),
    },
    {
      title: 'Cấp ban hành',
      render: record => (
        <CellEclipseBox>{record?.issue_level || '-'}</CellEclipseBox>
      ),
    },
    {
      title: 'Ban chủ trì xây dựng',
      render: record => (
        <CellEclipseBox>{record?.contruction_board || '-'}</CellEclipseBox>
      ),
    },
    {
      title: 'Trạng thái',
      render: record => (
        <CellEclipseBox>
          {
            ['Đã bãi bỏ', 'Hết hiệu lực', 'Còn hiệu lực'][
              parseInt(record.status) - 1
            ]
          }
        </CellEclipseBox>
      ),
    },
    {
      title: 'Tài liệu đính kèm',
      align: 'center',
      render: record => (
        <Button
          title="Tải xuống"
          type="text"
          shape="circle"
          onClick={async event => {
            event.stopPropagation()
            await downloadFile(record)
          }}>
          <DownloadMinimalisticOutlineIcon
            style={{ color: blue, width: 18, height: 18 }}
          />
        </Button>
      ),
    },
  ]

  const onChangeTable = useCallback(
    (current, size) => {
      if (size !== filterVBPC.size) {
        filterVBPC.page = 1
        filterVBPC.size = size
      } else {
        filterVBPC.page = current
      }
      documentStore.setFilterVBPC(filterVBPC)
    },
    [documentStore, filterVBPC]
  )

  useEffect(() => {
    loadingAnimationStore.showSpinner(true)
    documentStore
      .getVBPC(filterVBPC)
      .finally(() => loadingAnimationStore.showSpinner(false))
    return () => documentStore.clearDocument()
  }, [documentStore, filterVBPC, loadingAnimationStore])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Văn bản pháp chế | Tài liệu</title>
      </Helmet>

      <AppPageHeader
        title="Danh sách văn bản pháp chế"
        addon={
          <>
            <DocumentVBPCPageAdvanceFilterV2 />
            <AccessControlAction aclActionType={ACL_ACTION_TYPE.create__PHAP_CHE}>
              <Button
                onClick={() => history.push('/utility/vbpc/create')}
                type={'primary'}>
                <PlusCircleOutlined />
                Tạo Văn bản pháp chế
              </Button>
            </AccessControlAction>
          </>
        }
      />
      {/* {filterVBPC.isOpen ? (
        <Fragment> 
          <AdvanceFilterBlock />
          <div style={{ marginBottom: 16 }} />
        </Fragment>
      ) : null} */}
      <ContentBlockWrapper>
        <AppTable
          onRow={record => {
            return {
              onClick: () => history.push(`/utility/vbpc/view/${record.id}`),
            }
          }}
          rowKey={() => uuid()}
          columns={tableColumn}
          dataSource={listVBPC}
          pagination={false}
          onChange={onChangeTable}
        />
        <AppTablePagination
          current={filterVBPC.page}
          pageSize={filterVBPC.size}
          total={totalCount}
          onChange={onChangeTable}
          // showSizeChanger={false}
          // showLessItems
        />
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

DocumentVBPCPage.propTypes = {}

export default memo(
  inject('loadingAnimationStore', 'documentStore')(observer(DocumentVBPCPage))
)
